import { ChangeDetectionStrategy, Component, computed, input, output, viewChildren } from '@angular/core';

import { VppAsset } from '@rocksoft/mdm-sdk-v2';
import { VppAssetListItemComponent } from './vpp-asset-list-item.component';

@Component({
  selector: 'ml-mdm-vpp-asset-list-ui',
  templateUrl: './vpp-asset-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VppAssetListItemComponent],
})
export class VppAssetListComponent {
  readonly components = viewChildren<VppAssetListItemComponent>('item');
  readonly assets = input.required<VppAsset[]>();
  readonly selectedAssetChange = output<VppAsset | undefined>();

  public selectedIndex: number;
  private selectedAsset: VppAsset | undefined;

  public readonly sortedAssets = computed(() => {
    const assets = this.assets() ?? [];
    return [...assets].sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0);
  });

  public select(index: number) {
    this.selectedIndex = index;
    const selectedAsset = this.components()[this.selectedIndex].asset() as VppAsset;
    this.selectAsset(selectedAsset);
  }

  private selectAsset(selectedApplication: VppAsset | undefined) {
    if (this.selectedAsset !== selectedApplication) {
      this.selectedAsset = selectedApplication;
      this.selectedAssetChange.emit(this.selectedAsset);
    }
  }
}
